import {
  ExpressFleetMallsConfig,
  ExpressFleetMallsConfig_malls_edges_node,
  ExpressFleetMallsConfigVariables
} from "@saleor/autobooking/types/ExpressFleetMallsConfig";
import { ExpressFleetListUrlQueryParams } from "@saleor/autobooking/urls";
import { Container } from "@saleor/components/Container";
import MoreActions from "@saleor/components/MoreActions";
import PageBackNavigation from "@saleor/components/PageBackNavigation/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import useNavigator from "@saleor/hooks/useNavigator";
import { sectionNames } from "@saleor/intl";
import { PageListProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import ExpressFleetMallsTable from "../ExpressFleetMallsTable";

export interface ExpressFleetListPageProps extends PageListProps {
  params: ExpressFleetListUrlQueryParams;
  onBack?: () => void;
  refetch: (variables?: ExpressFleetMallsConfigVariables) => any;
  data: ExpressFleetMallsConfig;
  mallList: ExpressFleetMallsConfig_malls_edges_node[];
  isLoading: boolean;
  userType: any;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
}

const ExpressFleetListPage: React.FC<ExpressFleetListPageProps> = ({
  params,
  onBack,
  refetch,
  data,
  mallList,
  isLoading,
  userType,
  activeTab,
  setActiveTab,
  ...listProps
}) => {
  const intl = useIntl();
  const navigate = useNavigator();

  const breadcrumbDirectory = [
    {
      name: "Configuration",
      url: "/operations"
    },
    {
      name: "Express Fleet"
    }
  ];

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row"
          }}
        >
          <PageBackNavigation onBack={onBack} />
          <PageHeader title={intl.formatMessage(sectionNames.expressFleet)} />
        </div>

        <MoreActions
          id={"expressFleetListPageMoreActions"}
          items={[
            {
              action: () => navigate("/logs/express-fleet"),
              id: "expressFleetListPageViewActivityLogs",
              label: "View Activity Logs"
            }
          ]}
        />
      </div>

      <div>
        <ExpressFleetMallsTable
          params={params}
          mallList={mallList}
          refetch={refetch}
          isLoading={isLoading}
          disabled={false}
          userType={userType}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          {...listProps}
        />
      </div>
    </Container>
  );
};

export default ExpressFleetListPage;
